export default {
  // Page titles
  campaigns: {
    title: 'SMS Campaigns'
  },
  automation: {
    title: 'SMS Automation',
    ndc: 'No Deposit after Registration',
    inactive: 'Inactive Users',
    churn: 'Churned Users',
    welcome: 'Welcome SMS',
    restorage: 'Re-deposit after First Deposit',
    birthday: 'Birthday Reminder',
    vip: 'VIP Users',
    allMembers: 'All Members'
  },
  vip: {
    title: 'SMS VIP Users'
  },

  // Task types
  type: {
    bulk: 'Bulk Send',
    ndc: 'No Deposit',
    inactive: 'Inactive',
    churn: 'Churned',
    vip: 'VIP Tasks',
    welcome: 'Welcome SMS',
    restorage: 'Re-deposit after First Deposit',
    birthday: 'Birthday Reminder',
    unknown: 'Unknown'
  },

  // Form related
  form: {
    taskName: 'Task Name',
    taskNamePlaceholder: 'Please enter task name',
    country: 'Region',
    countryPlaceholder: 'Please select region',
    vip: 'VIP Level',
    vipPlaceholder: 'Please select VIP level',
    status: 'Status',
    statusPlaceholder: 'Please select status',
    template: 'SMS Template',
    templatePlaceholder: 'Please select SMS template',
    selectCategoryFirst: 'Please select template category first',
    agent: 'Agent',
    agentPlaceholder: 'Please enter agent name',
    haveLogin: 'Has Login',
    haveBet: 'Has Bet',
    inOut: 'User Type',
    inOutPlaceholder: 'Please select user type',
    sendTime: 'Send Timing',
    sendTimePlaceholder: 'Please enter value',
    depositOrder: 'Deposit Sequence',
    depositOrderPlaceholder: 'Please enter the specific count, e.g. 5',
    dailyPlaceholder: 'Please enter days',
    weeklyPlaceholder: 'Please enter 1-7 (1=Monday, 7=Sunday)',
    monthlyPlaceholder: 'Please enter 1-31 (day of month)',
    timeUnit: 'Time Unit',
    templateContentPlaceholder: 'Please select template first',
    templateContent: 'Template Content (Read-only)',
    importUsers: 'Import Users',
    importPhones: 'Import Phone Numbers',
    bulkSend: 'Bulk Send',
    selectFile: 'Select File (CSV; comma/space/newline; auto deduplication)',
    chooseFile: 'Choose File',
    uploaded: 'Uploaded',
    notImported: 'Not Imported',
    importUsersPlaceholder: 'Import usernames (CSV; comma/space/newline; auto deduplication)',
    importPhonesPlaceholder: 'Import Phone Numbers (CSV; comma/space/newline; auto deduplication)'
  },

  // Upload related
  upload: {
    invalidFileType: 'Please upload Excel related files (.xlsx, .xls, .xlsm, .xlsb, .csv, .txt)',
    success: 'Excel file uploaded successfully',
    failed: 'Excel file upload failed',
    error: 'Excel file upload failed: {{error}}',
    pleaseUploadFirst: 'Please upload Excel file first'
  },

  // User types
  inOut: {
    internal: 'Internal User',
    external: 'External User'
  },

  // Time units
  timeUnit: {
    minutes: 'Minutes',
    hours: 'Hours',
    days: 'Days',
    weeks: 'Weeks',
    months: 'Months'
  },

  // Table related
  table: {
    taskName: 'Task Name',
    template: 'Template',
    country: 'Country',
    vipLevel: 'VIP Level',
    sendTiming: 'Send Timing',
    status: 'Status',
    actions: 'Actions',
    createUser: 'Creator',
    createTime: 'Created At',
    operator: 'Operator',
    depositOrder: 'Deposit Sequence',
    depositOrderValue: 'Deposit attempt {{times}}'
  },

  // Condition labels
  condition: {
    haveLogin: 'Has Login',
    haveBet: 'Has Bet'
  },

  // Status related
  status: {
    enabled: 'Enabled',
    disabled: 'Disabled'
  },

  // Button related
  button: {
    create: 'Create Task',
    execute: 'Execute Now',
    sendNow: 'Send Now',
    uploadFile: 'Upload File',
    createInternalCampaign: 'Create Internal User Campaign',
    createExternalCampaign: 'Create External User Campaign',
    importLog: 'Import Log'
  },

  // Modal related
  modal: {
    createTitle: 'Create SMS Task',
    editTitle: 'Edit SMS Task',
    viewTitle: 'View SMS Task',
    importLogTitle: 'Import List Log',
    close: 'Close'
  },

  // Re-deposit task hint
  restorage: {
    hint: 'Eligible users: those who do not make another deposit within 23 hours after their Nth deposit will receive this SMS.'
  },

  // Advanced filter
  advancedFilter: {
    title: 'Advanced Filter',
    excludeUser: 'Exclude Official Website Users',
    excludeAgent: 'Exclude Agent Users',
    excludeAgentWithHint: 'Exclude Agent Users (Searchable, Multiple)',
    selectAgents: 'Select Agents to Exclude',
    selectAgentsPlaceholder: 'Please select agents (searchable, multiple)',
    off: 'Off',
    on: 'On',
    excludeAllAgents: 'Exclude All Agents',
    excludeSomeAgents: 'Exclude Some Agents',
    mobileValid: 'Mobile Number Verified Users',
    // VIP task specific
    recentLoginPrefix: 'Send only to users who logged in within the last',
    recentLoginSuffix: 'days',
    recentLoginFullText: 'Send only to users who logged in within the last [] days',
    recentLoginTooltip: 'System will filter users with login records in the last n days before sending (leave blank for no limit)',
    recentLoginDays: 'Users logged in within {{days}} days'
  },

  // Validation related
  validation: {
    taskNameRequired: 'Please enter task name',
    countryRequired: 'Please select country',
    templateRequired: 'Please select SMS template',
    sendTimeRequired: 'Please enter send time',
    timeUnitRequired: 'Please select time unit',
    weeklyRangeError: 'Weekly frequency must be between 1-7 (1=Monday, 7=Sunday)',
    monthlyRangeError: 'Monthly date must be between 1-31',
    agentRequired: 'Please select agents to exclude',
    recentDayRequired: 'Please enter number of days',
    recentDayRange: 'Days must be between 1-365',
    excludeUserAndAllAgentsConflict: 'Cannot select both "Exclude Official Website Users" and "Exclude All Agents" at the same time',
    excludeUserAndAllAgentsConflictSubmit: 'Cannot select both "Exclude Official Website Users" and "Exclude All Agents" at the same time, please modify before submitting',
    depositOrderRequired: 'Please enter deposit sequence',
    depositOrderMin: 'Deposit sequence must be at least 1',
    sendTimeMinutesMax: 'Minutes cannot exceed 4320',
    sendTimeHoursMax: 'Hours cannot exceed 72',
    sendTimeDaysMax: 'Days cannot exceed 30'
  },

  // Message related
  message: {
    queryFailed: 'Query failed',
    createSuccess: 'Created successfully',
    createFailed: 'Creation failed',
    updateSuccess: 'Updated successfully',
    updateFailed: 'Update failed',
    deleteSuccess: 'Deleted successfully',
    deleteFailed: 'Deletion failed',
    statusUpdateSuccess: 'Status updated successfully',
    statusUpdateFailed: 'Status update failed',
    executeSuccess: 'Executed successfully',
    executeFailed: 'Execution failed'
  },

  // Confirm related
  confirm: {
    delete: 'Are you sure to delete this task?',
    toggleStatus: 'Are you sure to toggle the status of this task?',
    execute: 'Are you sure to execute this task immediately?',
    send: 'Are you sure to send this task immediately?'
  },

  // Pagination related
  pagination: {
    total: 'Total {{total}} records'
  },

  // Import log
  importLog: {
    uploadFileStatus: {
      '80009001': 'Pending',
      '80009002': 'Complete'
    },
    header: {
      taskName: 'Task',
      importer: 'Importer',
      operator: 'Operator',
      latestImportTime: 'Latest Import Time',
      importFileName: 'Import File Name',
      importCompleteTime: 'Import Complete Time',
      importStatus: 'Import Status'
    },
    stats: {
      success: 'Success',
      failed: 'Failed',
      total: 'Total'
    },
    failureDetails: {
      title: 'Failure Details',
      searchPlaceholder: 'Search failed username',
      exportFailed: 'Export Failed',
      memberAccount: 'Member Account',
      failureReason: 'Failure Reason',
      failureTime: 'Failure Time',
      rowNumber: 'Row #',
      remarks: 'Remarks',
      hint: 'Note: Failed user accounts are kept for one month only',
      loading: 'Loading...',
      noFailedRecords: 'No failed records',
      noImportRecords: 'No import records',
      exportNotImplemented: 'Export not implemented'
    }
  }
};
